import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bomm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('bomm_token');
      localStorage.removeItem('bomm_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  },
);

// Normaliza el error de una respuesta (incl. proxy Ops) a texto legible.
export function errText(e, fallback = 'Error') {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => String(x?.msg || x).replace(/^Value error, /, '')).join(' · ');
  if (d && typeof d === 'object') {
    return d.message || d.error || d.detail || d.raw || JSON.stringify(d);
  }
  return e?.message || fallback;
}
